import { DateLib, DayPickerProps } from "react-day-picker";
import { ChevronIcon } from "../../materials/icons/chevron-icon/ChevronIcon";
import { DayPicker, Props, getMonthBounds } from "./DatePicker.Parts";

export const DatePicker = (initialProps: Props) => {
  const { components, formatters } = initialProps;
  const { startMonth, endMonth } = getMonthBounds(initialProps);

  const props: DayPickerProps = {
    ...initialProps,
    startMonth,
    endMonth,
    components: {
      ...components,
      Chevron: (props) => <ChevronIcon {...props} />,
    },
    formatters: {
      ...formatters,
      formatWeekdayName: (weekday, options, dateLib) =>
        (dateLib ?? new DateLib(options)).format(weekday, "EEEEE"),
    },
  };

  return <DayPicker {...props} />;
};
